import customSelect from 'custom-select';

export const categoryDropdown = () => {
    customSelect('#categories-dropdown')[4];
    const cstSel = document.querySelector('#categories-dropdown').customSelect
    cstSel.value = currentCategory;
    cstSel.select.addEventListener('change',
        (e) => {
            let url = homeUrl+'/category/'+e.target.value;
            window.location.href = url;
        });
}

